import { useEffect, useRef } from "preact/hooks";

/**
 * Bridges the vanilla-DOM block/markdown renderers into the Preact tree: the
 * renderers build real nodes directly (no `innerHTML`, see
 * `render/markdown.ts`), and this just mounts whatever they returned rather
 * than re-expressing them as JSX.
 */
export function DomMount({ node }: { node: Node }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.replaceChildren(node);
  }, [node]);

  return <div ref={ref} />;
}
